import { render, staticRenderFns } from "./OzlChildViewDialog.vue?vue&type=template&id=3d0c6f0f&scoped=true"
import script from "./OzlChildViewDialog.vue?vue&type=script&lang=js"
export * from "./OzlChildViewDialog.vue?vue&type=script&lang=js"
import style0 from "./OzlChildViewDialog.vue?vue&type=style&index=0&id=3d0c6f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c6f0f",
  null
  
)

export default component.exports